<div class="position-relative">
  <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
      <div class="row pt-10 pb-2 mx-auto" style="text-align: center;">
              <h1 class="text-white font-weight-bold">Terms and Conditions</h1>
      </div>
      <div class="container space-bottom-2 px-lg-12">
        <div class="row my-4 mt-4">
          <div class="col-12 col-lg-12 p-6 transparent-card">
          <p>
            Please read these terms and conditions carefully before using kopatours.com website operated by Kopa Tours.
            Your access to and use of kopatours.com is conditioned on your acceptance of and compliance with these terms. These terms apply to all visitors, users and others who access or kopatours.com.
            </p>
            <br/>
              <p>
            <strong>  Please read these terms and conditions carefully before using kopatours.com website operated by Kopa Tours.
                Your access to and use of kopatours.com is conditioned on your acceptance of and compliance with these terms. These terms apply to all visitors, users and others who access or kopatours.com. </strong>
                </p>
                <br/>
              <br/>
            <h3 class="porterHeader">Conditions of Use</h3>
            <br/>
            <p>We will provide services to you, which are subject to the conditions stated below in this document. Every time you visit this website, use its services or make a purchase, you accept the following conditions.</p>
          <br/>
            <h3 class="porterHeader">Privacy Policy</h3>
            <br/>
            <p>
              Before you continue using our website we advise you to read our <u><a class="light-link" routerLink="/helpful-information/privacy-policy">privacy policy</a></u> regarding our user data collection. It will help you better understand our practices.
          </p>
          <br/>
          <h3 class="porterHeader">Copyright</h3>
          <br/>
          <p>
            Content published on this website (digital downloads, images, texts, graphics, logos) is the property of Kopa Tours and/or its content creators and protected by international copyright laws. The entire compilation of the content
            found on this website is the exclusive property of Kopa Tours, with copyright authorship for this compilation by Kopa Tours.
            </p>
            <br/>
            <h3 class="porterHeader">Purchases</h3>
            <br/>
            <p>
              If you wish to purchase any product or service made available through the Kopa Tours FareHarbor booking process you may be asked to supply certain information relevant to your purchase including, without limitation, your full name, credit card number, date of birth, home address, email, and phone number.
          </p>
          <br/>
          <h3 class="porterHeader">Communications</h3>
          <br/>
          <p>
            The entire communication with us is electronic. Every time you send us an email or visit our website, you are going to be communicating with us. You hereby consent to receive communications from us. We will continue to communicate with you by posting news and notices on our website and by sending you emails. You also agree that all notices, disclosures, agreements and other communications we provide to you electronically meet the legal requirements that such communications be in writing.
            </p>
            <br/>
            <br/>
            <h3 class="porterHeader">Applicable Law</h3>
            <br/>
            <p>
              By visiting this website, you agree that the laws of Michigan, without regard to principles of conflict of laws, will govern these terms and conditions, or any dispute of any sort that might come between Kopa Tours and you, or its business partners and associates.
              </p>
              <br/>
              <br/>
              <h3 class="porterHeader">Disputes</h3>
              <br/>
              <p>
                Any dispute related in any way to your visit to this website or to products you purchase from us shall be arbitrated by state or federal court and you consent to the exclusive jurisdiction and venue of such courts.
                </p>
                <br/>
                <br/>
                <h3 class="porterHeader">Links To Other Websites</h3>
                <br/>
                <p>
                  Our service may contain links to third-party web sites or services that are not owned or controlled by Kopa Tours.
                  Kopa Tours has no control over, and assumes no responsibility for, the content, privacy policies, or practices of
                  any third party web sites or services. You further acknowledge and agree that Kopa Tours shall not be responsible
                  or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with
                  the use of or reliance on any such content, goods or services available on or through any such web sites or services.
                  </p>
                  <br/>
                  <br/>
                  <h3 class="porterHeader">Comments, Reviews, and Emails</h3>
                  <br/>
                  <p>
                    Visitors may post content as long as it is not obscene, illegal, defamatory, threatening, infringing of intellectual property rights, invasive of privacy or injurious in any other way to third parties. Content has to be free of software viruses, political campaign, and commercial solicitation.

                    We reserve all rights (but not the obligation) to remove and/or edit such content. When you post your content, you grant Kopa Tours non-exclusive, royalty-free and irrevocable right to use, reproduce, publish, modify such content throughout the world in any media.
                    </p>
                    <br/>
                    <br/>
                    <h3 class="porterHeader">License and Site Access</h3>
                    <br/>
                    <p>
                      We grant you a limited license to access and make personal use of this website. You are not allowed to download or modify it. This may be done only with written consent from us.
                      </p>
                      <br/>
                      <br/>
                      <h3 class="porterHeader">Contact Us</h3>
                      <br/>
                      <p>
                        If you have any questions about these terms, please <u><a class="light-link" routerLink="/helpful-information">contact us</a></u>.
                        </p>
                        <br/>
          <br/>
          </div>
          <div class="col mt-5 mt-lg-0 text-center">
          </div>
        </div>
      </div>
  </div>
</div>
